import type { HNOppgaveFrontend } from "../types/Resources";

import type { Referanse } from "../types/referanse";

import { ElementType } from "../enums/elementType";

export const getReferanseLenkeTekst = (
  referanse: Referanse,
  resources: HNOppgaveFrontend | undefined,
): string | undefined => {
  switch (referanse.Type) {
    case ElementType.Henvisning:
      return resources?.henvisning_lenke_tekst;
    case ElementType.Timeavtale:
      return resources?.timeavtale_lenke_tekst;
    default:
      return "";
  }
};

export const getReferanseLabelTekst = (
  referanse: Referanse,
  resources: HNOppgaveFrontend | undefined,
): string | undefined => {
  switch (referanse.Type) {
    case ElementType.Henvisning:
      return resources?.henvisning_label_tekst;
    case ElementType.Timeavtale:
      return resources?.timeavtale_label_tekst;
    default:
      return "";
  }
};
